module.exports = __webpack_public_path__ + "img/2.3e0bea0b.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":978,"height":604,"variants":[{"file":"img/2-480w.5621fde0e0b9.webp","width":480},{"file":"img/2-960w.d236fdd52f9c.webp","width":960},{"file":"img/2-978w.15268a2b63b1.webp","width":978}]};
}